module.exports = __webpack_public_path__ + "videos/8.ee21365.mp4";